'use client'

import { CART_PATH } from 'cart/constants/constants'
import { useCartState } from 'cart/context/CartProvider'
import { useNavigation } from 'hooks/useNavigation/useNavigation'
import dynamic from 'next/dynamic'
import type { ReactNode } from 'react'
import { Suspense, useRef } from 'react'
import { ButtonLarge } from './ButtonLarge/ButtonLarge'
import styles from './ShoppingCartButton.module.css'

const LimitsModal = dynamic(() =>
	import('../../../components/LimitsModal/LimitsModal').then(
		(module) => module.LimitsModal
	)
)

const AddNoStockModal = dynamic(() =>
	import('../../../components/AddNoStockModal/AddNoStockModal').then(
		(module) => module.AddNoStockModal
	)
)

export const ShoppingCartLarge = (): ReactNode => {
	const { openedLimitWarningModal, openedAddNoStockModal, showShoppingCart } =
		useCartState()
	const iconRef = useRef<HTMLDivElement>(null)
	const { navigate } = useNavigation()

	const handleClick = (e: React.MouseEvent) => {
		if (!showShoppingCart) {
			e.preventDefault()
			e.stopPropagation()
			navigate(CART_PATH)
		}
	}

	return (
		<div className={styles.userIconContainer}>
			<ButtonLarge handleClick={handleClick} iconRef={iconRef} />

			{openedLimitWarningModal && (
				<Suspense fallback={null}>
					<LimitsModal />
				</Suspense>
			)}
			{openedAddNoStockModal && (
				<Suspense fallback={null}>
					<AddNoStockModal />
				</Suspense>
			)}
		</div>
	)
}
